<template>
  <div id="protection-section">
    <img loading="lazy" width="58" height="70" :src="iconShield" alt="Ícone escudo">

    <h1 class="heading">Proteção em um clique</h1>

    <p>
      Você tem medo de que algum imprevisto aconteça com o seu aparelho? Com o Seguro Celular/Equipamentos Portáteis Ciclic, você fica tranquilo e não corre o risco de ficar sem ele
    </p>
  </div>
</template>

<script>
export default {
  name: 'ProtectionSection',
  computed: {
    iconShield () {
      return require(`@/assets/svg/icon-shield-green.svg`)
    }
  }
}
</script>

<style lang="scss" scoped>
#protection-section {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 104px 0;

  img {
    margin-bottom: 24px;
  }

  .heading {
    font-family: Oscine;
    font-style: normal;
    font-weight: bold;
    font-size: 48px;
    line-height: 62px;
    text-align: center;
    color: #324B68;
    padding: 12px 0 24px;
    position: relative;
    margin-bottom: 32px;

    &::before {
      background: #00E1CD;
      bottom: -4px;
      content: '';
      height: 8px;
      left: calc(50% - 51px);
      width: 102px;
      position: absolute;
    }
  }

  p {
    font-family: Rubik;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 24px;
    text-align: center;
    color: #707070;
    max-width: 624px;
  }
}
</style>
